// The menu badge is a small pill next to a label: past two digits the exact
// number stops being something anyone acts on, and only makes the badge grow
// over the label it sits next to. Three digits become "99+".
export const NOTIFICATION_CAP = 99;

export function formatNotificationCount(count: number): string {
  return count > NOTIFICATION_CAP ? `${NOTIFICATION_CAP}+` : String(count);
}
